import BudgetReportAccountRowVisibility from "./BudgetReportAccountRowVisibility.js";
import HideAccountsVisibility from "./HideAccountsVisibility.js";
import HideNoDataAccountsVisibility from "./HideNoDataAccountsVisibility.js";
import ModelFactory from "../../ModelFactory.js";
import ShowAccountsVisibility from "./ShowAccountsVisibility.js";

/**
 * TODO: write documentation
 */
class AccountRowVisibilityFactory extends ModelFactory {
	hideAccountsVisibility() {
		return HideAccountsVisibility.instance();
	}

	hideNoDataAccountsVisibility() {
		return HideNoDataAccountsVisibility.instance();
	}

	showAccountsVisibility() {
		return ShowAccountsVisibility.instance();
	}

	budgetReportVisibility(...rest) {
		return new BudgetReportAccountRowVisibility(...rest);
	}

	defaultVisibility() {
		return this.hideNoDataAccountsVisibility();
	}

	allUserVisibleAccountVisibilities() {
		return this.allUserVisibleAccountVisibilityClasses().map((klass) =>
			klass.instance(),
		);
	}

	allUserVisibleAccountVisibilityClasses() {
		return [
			// Order must be the same as the one of the Enum on the
			// server:
			ShowAccountsVisibility,
			HideNoDataAccountsVisibility,
			HideAccountsVisibility,
		];
	}

	serialize(visibility) {
		return this.allUserVisibleAccountVisibilities().indexOf(visibility);
	}

	allClasses() {
		return this.allUserVisibleAccountVisibilityClasses();
	}

	_getTypeFromJson(index) {
		return index;
	}

	_findClassFromType(index = 0) {
		return this.allUserVisibleAccountVisibilityClasses()[index];
	}

	_instantiate(klass) {
		return klass.instance();
	}
}

const accountRowVisibilityFactory = new AccountRowVisibilityFactory();

export default accountRowVisibilityFactory;
